import { render, staticRenderFns } from "./SaleCommission.vue?vue&type=template&id=6a25dc41"
import script from "./SaleCommission.vue?vue&type=script&lang=js"
export * from "./SaleCommission.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports